var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    tableBottomPadding: spacing.medium,
    colorGreen: colors.shamrock,
    colorGray: colors.tiara,
    cellPadding: '0.75rem 0.75rem'
  };
};
export default generateComponentTheme;